export default "__VITE_ASSET__29d62364__"